
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookFallAnimal",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "WildbuchEintragFallwild",
      page: "WildbuchEintragTierartFallwild",
      remoteId: "",
      

      

    });
    return {
      request
    };
  }
};
